"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/**
 * Clipboard utils
 */
const Clipboard = {
  navigatorCopy(str) {
    return (0, _asyncToGenerator2.default)(function* () {
      try {
        yield navigator.clipboard.writeText(str);
      } catch (error) {
        console.error(error); // eslint-disable-line no-console
      }
    })();
  },
  copy(str) {
    if (navigator.clipboard) {
      return this.navigatorCopy(str);
    }
    const el = document.createElement('textarea');
    el.value = str || ' ';
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
};
var _default = exports.default = Clipboard;